import MicroModal from 'micromodal';
import $ from 'jquery';

$('.js-open-modal-route').on('click', function () {
  const route = $(this).data('modal-route');
  const id = `modal-${route}`;
  MicroModal.show(id, {
    onShow: (modal) => {
      const $slickNext = $(`#${modal.id} .slick-arrow[aria-label='next']`);
      if ($slickNext.length != 0) {
        $slickNext[0].focus();
      }
    },
  });
});

$('.js-close-all-modals').on('click', function () {
  closeAllModals();
});

$('[data-micromodal-close]').on('click', function () {
  const id = $(this).closest('.modal.is-open').attr('id');
  MicroModal.close(id);
});

// $('.force-modal').on('click', function() {
//   // closeAllModals();
//   const id = $(this).data('force');
//   MicroModal.show(`modal-${id}`);
// })

$('.modal__overlay').on('click', function () {
  closeAllModals();
});

$('.modal__container').on('click', function (e) {
  e.stopPropagation();
});

$('.js-modal-route').on('click', function () {
  const currentModal = $(this).closest('.modal');
  const currentModalID = currentModal.attr('id');
  const route = $(this).data('modal-route');
  const targetModalID = `modal-${route}`;

  $('.modal').each(function () {
    if ($(this).attr('id') == targetModalID) {
      const targetModal = $(this);
      const targetModalBack = targetModal.find('.js-route-back');
      targetModalBack.attr('data-back-to', currentModalID.replace('modal-', ''));
    } else {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open');
      }
    }
  });
  MicroModal.show(targetModalID, {
    onShow: (modal) => {
      const $slickNext = $(`#${modal.id} .slick-arrow[aria-label='next']`);
      if ($slickNext.length != 0) {
        $slickNext[0].focus();
      }
    },
  });
});

$('.js-route-back').on('click', function () {
  // currently open
  const currentModal = $(this).closest('.modal.is-open');
  const currentModalID = currentModal.attr('id');
  // need to go back to
  const routeBackTo = $(this).attr('data-back-to');
  if (routeBackTo) {
    const targetModalID = `modal-${routeBackTo}`;
    MicroModal.show(targetModalID, {
      onShow: (modal) => {
        const $slickNext = $(`#${modal.id} .slick-arrow[aria-label='next']`);
        if ($slickNext.length != 0) {
          $slickNext[0].focus();
        }
      },
    });
  }
  // close route / remove back info
  $(this).attr('data-back-to', '');
  MicroModal.close(currentModalID);
});

function closeAllModals() {
  const openModals = $('.modal.is-open');
  const openModalsIds = [];
  openModals.each(function () {
    openModalsIds.push($(this).attr('id'));
  });
  openModalsIds.forEach((id) => MicroModal.close(id));
}
